import { Analytics } from '@/modules/analytics/types';
import { all_roles } from '@/utils';

const access_roles = {
  [Analytics.Pages.ANALYTICS]: all_roles,
};

export default access_roles;
